var render = function (_h,_vm) {var _c=_vm._c;return _c('q-tooltip',_vm._b({attrs:{"anchor":_vm.props.anchor,"self":_vm.props.self,"content-style":Object.assign({}, {zIndex: 99999,
    padding: 'var(--r-space-sm)',
    background: 'var(--r-secondary-1)',
    overflow: 'hidden'},
    _vm.props.contentStyle),"offset":_vm.props.offset}},'q-tooltip',_vm.data.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }